import { StatsigUser } from '@statsig/react-bindings'

export interface StatsigServerProps {
  user: StatsigUser
  data: string
  key: string
}

export enum StasigLoadingState {
  UNINITIALIZED = 'Uninitialized',
  LOADING = 'Loading',
  READY = 'Ready',
}
